import styled from 'styled-components';
import {JackpotBetWidgetLogoDefaultBox} from './jackpot-bet-widget-logo.default.box';

export const JackpotBetWidgetLogoMRGreenBox = styled(JackpotBetWidgetLogoDefaultBox)`
    height: 16rem;
    width: 19rem;  
    padding: 5rem;
`;

